<template>
  <v-card align="center" justify="center" min-width="30vw" outlined>
    <v-card-title>
      <v-list-item>
        <v-list-item-title><h2>{{ $t('allUserAssets') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="overflow-y-auto px-5 py-7" style="max-height: 70vh !important;">
      <v-container fluid>
        <v-row style="border-bottom: 1px solid #e3e3e3;" v-for="strategy in this.$store.state.user.strategies" v-bind:key="strategy.id" dense>
          <v-col cols="9" class="d-flex align-center justify-start">
            <h3 class="my-0 text-start" style="font-size: 14px; color: #111111">{{ truncateString(strategy.name, 21) }}</h3>
            <p class="my-0 ml-2" style="font-size: 13px;">{{ truncateString(strategy.description, 21) }}</p>
          </v-col>
          <v-col cols="3" class="d-flex align-center justify-end">
            <v-chip small @click="removeStrategy(strategy)"><p class="my-0" style="font-size: 14px !important;">{{ $t('remove') }}
              <v-icon class="ml-1" x-small>fa-times</v-icon>
            </p></v-chip>
          </v-col>
        </v-row>
      </v-container>
      <v-btn @click="close">{{ $t('close') }}</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SeeAllStrategies",
  methods: {
    removeStrategy(strategy) {
      this.$emit('removeStrategy', strategy);
    },
    truncateString(string, maxLength) {
      return (string !== null && string.length > maxLength) ? `${string.substring(0, maxLength)}...` : string;
    },
    close() {
      this.$emit('closeWindow');
    },
  },
}
</script>

<style scoped>

</style>



